/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'

import { AccessGroupType } from '@schemas'

interface PropsType {
	group: AccessGroupType
}

export const AccessGroupListItem = (props: PropsType) => {
	const { group } = props

	return (
		<View css={style}>
			<View className="groupInnerView">
				<View>
					<Text className="name" i18n={group.i18n}>
						{group.name}
					</Text>
				</View>
			</View>
		</View>
	)
}

const style = css({
	width: '100%',

	'.groupInnerView': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
		padding: '0.5rem 0',

		'.name': {
			margin: 0,
			textAlign: 'left',
		},
		'.path': {
			marginTop: '0.3rem',
			marginBottom: 0,
			fontSize: '10px',
		},
	},
})
